import { WEBCODE_SUCCESS } from "./const";

function action(targetUrl) {
  return {
    type: WEBCODE_SUCCESS,
    targetUrl,
  };
}

export default action;
